import styled, { css } from "styled-components";
import Select from "ui/common/components/input/Select/Select";

export const RoleSelectRoot = styled(Select)(
    ({ theme }) => css`
        .SelectDisplay {
            width: 18rem;
        }
        .Select {
            .SelectMenu {
                padding: ${theme.spacing.vertical(4)};
            }
        }
    `,
) as typeof Select;
